import { render, staticRenderFns } from "./Rental.vue?vue&type=template&id=05150584&scoped=true&"
import script from "./Rental.vue?vue&type=script&lang=ts&"
export * from "./Rental.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05150584",
  null
  
)

export default component.exports